import { DigitalVisitReasonEnum } from "@/lib/__generated/api";

export const STORAGE_SESSION_ID_KEY = "sessionId";
export const PATIENT_SERVICES_BASE_PATH = "/patient-services/";

export enum DataLayerStepNames {
  timeSelection = "date_time_selection",
  contactInformation = "additional_patient_information",
  patientInformation = "patient_information",
  reasonForVisit = "reason_for_visit",
  reasonSelect = "reason_selected",
  review = "review",
  confirmation = "confirmation",
}

export const REASON_FOR_VISIT_MAPPING: Partial<Record<DigitalVisitReasonEnum, number>> = {
  [DigitalVisitReasonEnum.Emergency]: 1,
  [DigitalVisitReasonEnum.BrokenToothToothPain]: 2,
  [DigitalVisitReasonEnum.Implants]: 3,
  [DigitalVisitReasonEnum.Dentures]: 4,
  [DigitalVisitReasonEnum.ClearAligners]: 5,
  [DigitalVisitReasonEnum.Other]: 6,
  [DigitalVisitReasonEnum.HealthyMouthMovement]: 7,
};
